import * as ewe from "@eyeo/webext-ad-filtering-solution/ui";
import DOMPurify from "dompurify";
import * as messaging from "../../core/messaging/front";
import * as subscriptions from "../../core/subscriptions/shared";
import * as filters from "../../filters/shared";
function start() {
    if (self.modulesAsGlobal) {
        return;
    }
    self.modulesAsGlobal = { messaging, filters, ewe, subscriptions };
    Object.assign(self, {
        DOMPurify,
        ewe,
    });
}
start();
